import { render } from "./ValorPadraoSelecao.vue?vue&type=template&id=ca0aba5c&scoped=true&ts=true"
import script from "./ValorPadraoSelecao.vue?vue&type=script&lang=ts"
export * from "./ValorPadraoSelecao.vue?vue&type=script&lang=ts"

import "./ValorPadraoSelecao.vue?vue&type=style&index=0&id=ca0aba5c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0aba5c"]])

export default __exports__